// extracted by mini-css-extract-plugin
export default {"page":"ixEAR","page_title":"UDkJV","description":"GOBqc","categories":"uZ2UN","category_item":"AKlGI","category_link":"SN1og"};